import { GovIcon } from '@gov-design-system-ce/react';
import { Button } from '@gov-nx/ui/web';
import type { IUseBoolean } from '@gov-nx/utils/common';

interface ActionButtonsProps {
	isEditing: IUseBoolean;
	isChanging: IUseBoolean;
	externalEditUrl?: string;
	isNeedForVerification: boolean;
	isConfirmationOpen: IUseBoolean;
	value?: string;
	strings: {
		buttons: {
			edit: {
				label: string;
				wcagLabel: string;
			};
			cancel: {
				label: string;
				wcagLabel: string;
			};
			delete: {
				wcagLabel: string;
			};
			externalEdit: {
				label: string;
				wcagLabel: string;
			};
		};
	};
}

export const ActionButtons = ({
	isNeedForVerification,
	isEditing,
	externalEditUrl,
	isChanging,
	isConfirmationOpen,
	value,
	strings,
}: ActionButtonsProps) => {
	if (externalEditUrl) {
		return (
			<Button
				asChild
				onClick={isChanging.setFalse}
				aria-label={strings.buttons.externalEdit.wcagLabel}
				color="primary"
				type="base"
				size="m">
				<a
					href={externalEditUrl}
					rel="noreferrer"
					target="_blank">
					{strings.buttons.externalEdit.label}
				</a>
			</Button>
		);
	}

	if (isNeedForVerification) {
		return null;
	}

	if (isChanging.value) {
		return (
			<Button
				onClick={isChanging.setFalse}
				aria-label={strings.buttons.cancel.wcagLabel}
				color="primary"
				type="base"
				size="m">
				{strings.buttons.cancel.label}
			</Button>
		);
	}
	if (isEditing.value) {
		return (
			<Button
				onClick={isEditing.setFalse}
				aria-label={strings.buttons.cancel.wcagLabel}
				color="primary"
				type="base"
				size="m">
				{strings.buttons.cancel.label}
			</Button>
		);
	}
	return (
		<div className="flex">
			<Button
				onClick={isEditing.setTrue}
				aria-label={strings.buttons.edit.wcagLabel}
				color="primary"
				type="base"
				size="m">
				{strings.buttons.edit.label}
			</Button>
			{value && (
				<Button
					onClick={isConfirmationOpen.setTrue}
					aria-label={strings.buttons.delete.wcagLabel}
					title={strings.buttons.delete.wcagLabel}
					color="error"
					type="base"
					size="m">
					<GovIcon
						name="trash"
						type="templates"
					/>
				</Button>
			)}
		</div>
	);
};
